import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation VideoServiceEnable($uid: String!){
        video_service_enable (uid: $uid) {
            success
        }
    }
`;

export async function videoServiceEnable(uid: string): Promise<{ success: boolean }> {
    const result: FetchResult<{ video_service_enable: { success: boolean }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { uid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.video_service_enable;
}
